import React, { Component, Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import Layout from "./hoc/Layout/Layout";
import ProtectedRoute, {
  SignUpRoute,
  LoginRoute,
  ProtectedOndemand,
} from "./services/ProtectedRoute";

import { CheckOffline } from "./components/CheckOnline/CheckOnline";
import "./App.scss";
import { CheckValue, env } from "./services/CommonFunction";
import {
  access,
  getWhiteLabelData,
  internet,
  setColor,
  staticVar,
  themeData,
} from "./services/Constants";
import Modals, { ErrorUI } from "./components/UI/Modals/Modals";
import Spinner from "./components/UI/Loader/Loader";
import Download from "./components/ReusableComponents/Download/Download";
import { selectIcon, SVG } from "./components/UI/selector";
import Ondemand from "./containers/Ondemand/Ondemand";
import ForgotPasswordComponent from "./containers/SignUpSteps/ForgotPassword/ForgotPassword";
import ProfileLayout from "./hoc/ProfileLayout/ProfileLayout";
import SignInComponent from "./containers/SignIn/SignIn";
import SignUpComponent from "./containers/SignUpSteps/SignUp/SignUp";
import LiveActivity from "./containers/LiveActivity/LiveActivity";
import { browserName } from "react-device-detect";
import { AppVersions } from "./services/CallApi";
import { IVSPreviewHandeler } from "./hoc/IVSPreviewHandler/IVSPreviewHandler";

// ============ Code Splitting [Route Lazyload] ==============
// const SignUpSteps      = React.lazy( () => import('./containers/SignUpSteps/SignUpSteps'));
// const InternalLayout   = React.lazy( () => import('./hoc/InternalLayout/InternalLayout'));
// ===========================================================

class App extends Component {
  state = {
    start: browserName === "Chrome",
    player: null,
    isOnline: navigator.onLine,
  };

  componentDidMount() {
    this.eventListner("addEventListener");
    this.setState((prevState) => {
      if (prevState.player === null) {
        return { player: window.IVSPlayer.create() };
      }
    });
    const whiteLabelData = getWhiteLabelData();
    setColor(themeData[whiteLabelData.appName]);
    AppVersions().then((data) => {
      if (CheckValue(data.data.app_assets)) {
        if (
          getComputedStyle(document.documentElement).getPropertyValue(
            "--theme-color"
          ) === "dark"
        ) {
          document.documentElement.style.setProperty(
            "--logo-url",
            "url(" + data.data.app_assets.dark_theme_assets.brand_logo + ")"
          );
        } else {
          document.documentElement.style.setProperty(
            "--logo-url",
            "url(" + data.data.app_assets.light_theme_assets.brand_logo + ")"
          );
        }
      }
      localStorage.setItem("privacyPolicyLink", data.data.privacy_policy_link);
    });

    console.log("app-version-", staticVar.version);
    if (!this.state.start) {
      ErrorUI("We currently do not support this browser. Please use Chrome.");
      return;
    }

    if (localStorage.getItem("access")) {
      const temp = JSON.parse(localStorage.getItem("access"));
      Object.keys(access).map((el) => {
        if (CheckValue(temp[el])) {
          access[el].value = temp[el];
        }
      });
    }
    if (!CheckValue(internet.offline)) {
      let temp = selectIcon("offline");
      this.convertImgToBase64URL(temp);
    }
  }

  componentWillUnmount() {
    this.eventListner("removeEventListener");
  }

  eventListner = (status) => {
    window[status]("offline", (e) => {
      this.setState({ isOnline: false });
      console.log("offline");
    });

    window[status]("online", (e) => {
      this.setState({ isOnline: true });
      console.log("online");
    });
  };

  convertImgToBase64URL(url, callback, outputFormat) {
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        dataURL;
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL(outputFormat);
      internet.offline = dataURL;
      canvas = null;
    };
    img.src = url;
  }

  render() {
    const { isOnline } = this.state;
    return (
      <Layout>
        {isOnline ? (
          <React.Fragment>
            <Modals />
            <Spinner />
            <Download />
            {this.state.start ? (
              <Suspense fallback={<div>Loading...</div>}>
                <IVSPreviewHandeler player={this.state.player} />
                <Switch>
                  <LoginRoute
                    path="/SignIn"
                    exact
                    component={SignInComponent}
                  />
                  <LoginRoute
                    path="/SignUp"
                    exact
                    component={SignUpComponent}
                  />
                  <LoginRoute
                    path="/ForgotPassword"
                    exact
                    component={ForgotPasswordComponent}
                  />
                  {/* ================Redirect to dashboard==================== */}
                  <ProtectedOndemand
                    exact
                    path="/LiveActivity"
                    component={LiveActivity}
                  />
                  <ProtectedOndemand
                    exact
                    path="/Ondemand"
                    component={Ondemand}
                  />
                  <ProtectedRoute path="/" component={ProfileLayout} />
                  {/* ==========================Redirect to Not Found Page=============================== */}
                  <Route
                    path="*"
                    exact
                    component={() => <h1>404 Not Fount !</h1>}
                  />
                </Switch>
              </Suspense>
            ) : null}
          </React.Fragment>
        ) : (
          <CheckOffline />
        )}
        <span className="hide-detect">
          {isOnline ? "Online 🆗" : "⚠️Offline⚠️"}
        </span>
      </Layout>
    );
  }
}

export default App;
